export default () => ( {
    foo: false,
    EnvoyInput: '',
    onClickSuggestedEnvoy( event ) {
        let name = event.target.closest( "[ data-suggestion ]" ).getAttribute( "data-suggestion" );
        // console.log( "onClickSuggestedEnvoy", { event, name } );
        this.EnvoyInput = name.length ? name : this.EnvoyInput;
    },
    init() {
        // console.log( "Signup Form" );
    }
} );
